// extracted by mini-css-extract-plugin
export var form = "_cd-0";